export const getPositionLetter = (position) => {
  //console.log("Getting position letter for position:", position);
  switch (position) {
    case 0: // Team
      return "T";
    case 1: // Defender
      return "D";
    case 2: // Midfielder
      return "M";
    case 3: // Forward
      return "F";
    case 4: // Goalkeeper
      return "G";
    case 5: // BasketballGuard
      return "BG";
    case 6: // BasketballForward
      return "BF";
    case 7: // BasketballCenter
      return "BC";
    case 8: // CricketBowler
      return "BL";
    case 9: // CricketBatsmen
      return "BT";
    case 10: // CricketWicketKeeper
      return "WK";
    case 11: // AllRounder
      return "AR";
    case 12: // Position
      return "P";
    case 13: // HockeyCenter
      return "C";
    case 14: // HockeyDefenseman
      return "D";
    case 15: // HockeyRightWing
      return "RW";
    case 16: // HockeyLeftWing
      return "LW";
    case 17: // AustralianFootballRuck
      return "R";
    case 18: // RugbyFullback
      return "FB";
    case 19: // RugbyCentre
      return "C";
    case 20: // RugbyWing
      return "W";
    case 21: // RugbyHalves
      return "HA";
    case 22: // RugbyHoocker
      return "HK";
    case 23: // RugbyMiddleForward
      return "MF";
    case 24: // RugbyEdgeForward
      return "EF";
    case 25: // FootballQuarterBack
      return "QB";
    case 26: // FootballWideReceiver
      return "WR";
    case 27: // FootballTightEnd
      return "TE";
    case 28: // FootballRunningBack
      return "RB";
    default:
      return "?";
  }
};

// Lineup positions enum (slot positions in the lineup)
export const LineupPositions = {
  // Football Positions
  Team: 0,
  DefenderLeft: 1,
  DefenderRight: 2,
  MidfieldLeft: 3,
  MidfieldRight: 4,
  Forward: 5,
  MidfieldCenter: 6,

  // Horse Racing positions
  Jockey: 7,
  HorseTopLeft: 8,
  HorseTopRight: 9,
  HorseBottomLeft: 10,
  HorseBottomRight: 11,

  // Basketball Positions
  BasketballGuardLeft: 12,
  BasketballGuardRight: 13,
  BasketballForwardLeft: 14,
  BasketballForwardRight: 15,
  BasketballCenter: 16,
  BasketballFlex: 17,

  // Cricket Positions
  CricketBowlerLeft: 18,
  CricketBowlerRight: 19,
  CricektBatsmenLeft: 20,
  CricektBatsmenRight: 21,
  CricketWicketKeeperCenter: 22,
  CricketFlex: 23,

  // Hockey Positions
  HockeyTeam: 24,
  HockeyCenter: 25,
  HockeyDefenseLeft: 26,
  HockeyDefenseRight: 27,
  HockeyRightWing: 28,
  HockeyLeftWing: 29,
  HockeyFlex: 30,

  // American Football Positions
  FootballQuarterBack: 31,
  FootballWideReceiverLeft: 32,
  FootballWideReceiverRight: 33,
  FootballTightEnd: 34,
  FootballRunningBack: 35,
  FootballFlex: 36,
  AustralianFootballRuck: 37,

  // Rugby Positions
  RugbyFullback: 38,
  RugbyHalves: 39,
  RugbyHoocker: 40,
  RugbyMiddleForward: 41,
  RugbyEdgeForward: 42,
  RugbyFlex: 43,
};

// Scoreable positions enum (player card positions)
export const ScoreablePositions = {
  Team: 0,
  Defender: 1,
  Midfielder: 2,
  Forward: 3,
  Goalkeeper: 4,
  BasketballGuard: 5,
  BasketballForward: 6,
  BasketballCenter: 7,
  CricketBowler: 8,
  CricketBatsmen: 9,
  CricketWicketKeeper: 10,
  AllRounder: 11,
  Possition: 12,
  HockeyCenter: 13,
  HockeyDefenseman: 14,
  HockeyRightWing: 15,
  HockeyLeftWing: 16,
  AustralianFootballRuck: 17,
  RugbyFullback: 18,
  RugbyCentre: 19,
  RugbyWing: 20,
  RugbyHalves: 21,
  RugbyHoocker: 22,
  RugbyMiddleForward: 23,
  RugbyEdgeForward: 24,
  FootballQuarterBack: 25,
  FootballWideReceiver: 26,
  FootballTightEnd: 27,
  FootballRunningBack: 28,
};

export const hockeySlotPositions = [
  {
    playerPosition: 24, // LineupPositions.HockeyTeam
    name: "Team",
  },
  {
    playerPosition: 25, // LineupPositions.HockeyCenter
    name: "HockeyCenter",
  },
  {
    playerPosition: 26, // LineupPositions.HockeyDefenseLeft
    name: "HockeyDefenseman1",
  },
  {
    playerPosition: 27, // LineupPositions.HockeyDefenseRight
    name: "HockeyDefenseman2",
  },
  {
    playerPosition: 28, // LineupPositions.HockeyRightWing
    name: "HockeyRightWing",
  },
  {
    playerPosition: 29, // LineupPositions.HockeyLeftWing
    name: "HockeyLeftWing",
  },
  {
    playerPosition: 30, // LineupPositions.HockeyFlex
    name: "HockeyFlex",
  },
];

export const soccerSlotPositions = [
  {
    playerPosition: 0, // LineupPositions.Team
    name: "Team",
  },
  {
    playerPosition: 1, // LineupPositions.DefenderLeft
    name: "Defender1",
  },
  {
    playerPosition: 2, // LineupPositions.DefenderRight
    name: "Defender2",
  },
  {
    playerPosition: 3, // LineupPositions.MidfieldLeft
    name: "Midfielder1",
  },
  {
    playerPosition: 4, // LineupPositions.MidfieldRight
    name: "Midfielder2",
  },
  {
    playerPosition: 5, // LineupPositions.Forward
    name: "Forward1",
  },
  {
    playerPosition: 6, // LineupPositions.MidfieldCenter
    name: "Forward2",
  },
];

export const footballSlotPositions = [
  {
    playerPosition: 0, // LineupPositions.Team
    name: "Team",
  },
  {
    playerPosition: 32, // LineupPositions.FootballQuarterBack
    name: "QuarterBack",
  },
  {
    playerPosition: 36, // LineupPositions.FootballRunningBack
    name: "RunningBack",
  },
  {
    playerPosition: 33, // LineupPositions.FootballWideReceiverLeft
    name: "WideReceiver1",
  },
  {
    playerPosition: 34, // LineupPositions.FootballWideReceiverRight
    name: "WideReceiver2",
  },
  {
    playerPosition: 35, // LineupPositions.FootballTightEnd
    name: "TightEnd",
  },
  {
    playerPosition: 37, // LineupPositions.FootballFlex
    name: "Flex",
  },
];

export const basketballSlotPositions = [
  {
    playerPosition: 0, // LineupPositions.Team
    name: "Team",
  },
  {
    playerPosition: 12, // LineupPositions.BasketballGuardLeft
    name: "Guard1",
  },
  {
    playerPosition: 13, // LineupPositions.BasketballGuardRight
    name: "Guard2",
  },
  {
    playerPosition: 14, // LineupPositions.BasketballForwardLeft
    name: "Forward1",
  },
  {
    playerPosition: 15, // LineupPositions.BasketballForwardRight
    name: "Forward2",
  },
  {
    playerPosition: 16, // LineupPositions.BasketballCenter
    name: "Center",
  },
  {
    playerPosition: 17, // LineupPositions.BasketballFlex
    name: "Flex",
  },
];

export const cricketSlotPositions = [
  {
    playerPosition: LineupPositions.Team,
    name: "Team",
  },
  {
    playerPosition: LineupPositions.CricektBatsmenLeft,
    name: "Batler",
  },
  {
    playerPosition: LineupPositions.CricektBatsmenRight,
    name: "Batler",
  },
  {
    playerPosition: LineupPositions.CricketBowlerRight,
    name: "Bowler",
  },
  {
    playerPosition: LineupPositions.CricketBowlerLeft,
    name: "Bowler",
  },
  {
    playerPosition: LineupPositions.CricketWicketKeeperCenter,
    name: "All Rounder",
  },
  {
    playerPosition: LineupPositions.CricketFlex,
    name: "Bowler",
  },
];

export const australianFootballSlotPositions = [
  {
    playerPosition: LineupPositions.Team,
    name: "Team",
  },
  {
    playerPosition: LineupPositions.DefenderLeft,
    name: "Defender",
  },
  {
    playerPosition: LineupPositions.DefenderRight,
    name: "Defender",
  },
  {
    playerPosition: LineupPositions.MidfieldLeft,
    name: "Midfielder",
  },
  {
    playerPosition: LineupPositions.MidfieldRight,
    name: "Midfielder",
  },
  {
    playerPosition: LineupPositions.Forward,
    name: "Forward",
  },
  {
    playerPosition: LineupPositions.AustralianFootballRuck,
    name: "Ruck",
  },
];

export const rugbySlotPositions = [
  {
    playerPosition: LineupPositions.Team,
    name: "Team",
  },
  {
    playerPosition: LineupPositions.RugbyFullback,
    name: "Fullback",
  },
  {
    playerPosition: LineupPositions.RugbyHalves,
    name: "Halves",
  },
  {
    playerPosition: LineupPositions.RugbyHoocker,
    name: "Hoocker",
  },
  {
    playerPosition: LineupPositions.RugbyMiddleForward,
    name: "Middle Forward",
  },
  {
    playerPosition: LineupPositions.RugbyEdgeForward,
    name: "Edge Forward",
  },
  {
    playerPosition: LineupPositions.RugbyFlex,
    name: "Flex",
  },
];

// Default to hockey for backward compatibility
export const slotPositions = hockeySlotPositions;

// TenantSportTypes enum values
export const TenantSportTypes = {
  Hockey: 0,
  Soccer: 1,
  Football: 2,
  Basketball: 3,
  Cricket: 4,
  AustralianFootball: 5,
  Rugby: 6,
};

export const getSlotPositionsBySport = (sportType) => {
  switch (sportType) {
    case TenantSportTypes.Hockey:
      return hockeySlotPositions;
    case TenantSportTypes.Soccer:
      return soccerSlotPositions;
    case TenantSportTypes.Football:
      return footballSlotPositions;
    case TenantSportTypes.Basketball:
      return basketballSlotPositions;
    case TenantSportTypes.Cricket:
      return cricketSlotPositions;
    case TenantSportTypes.AustralianFootball:
      return australianFootballSlotPositions;
    case TenantSportTypes.Rugby:
      return rugbySlotPositions;
    default:
      return hockeySlotPositions;
  }
};

export const isTeamPosition = (position) => {
  return position === 0;
};

// Map lineup position to player position for card filtering
export const getPlayerPositionFromLineupPosition = (lineupPosition) => {
  console.log("Mapping lineup position:", lineupPosition);
  // Team position
  if (lineupPosition === LineupPositions.Team || lineupPosition === LineupPositions.HockeyTeam) return ScoreablePositions.Team;

  // Soccer/Football positions
  if (lineupPosition === LineupPositions.DefenderLeft || lineupPosition === LineupPositions.DefenderRight) return ScoreablePositions.Defender;
  if (lineupPosition === LineupPositions.MidfieldLeft || lineupPosition === LineupPositions.MidfieldRight || lineupPosition === LineupPositions.MidfieldCenter) return ScoreablePositions.Midfielder;
  if (lineupPosition === LineupPositions.Forward) return ScoreablePositions.Forward;

  // Hockey positions
  if (lineupPosition === LineupPositions.HockeyCenter || lineupPosition === LineupPositions.HockeyFlex) return ScoreablePositions.HockeyCenter;
  if (lineupPosition === LineupPositions.HockeyDefenseLeft || lineupPosition === LineupPositions.HockeyDefenseRight) return ScoreablePositions.HockeyDefenseman;
  if (lineupPosition === LineupPositions.HockeyRightWing) return ScoreablePositions.HockeyRightWing;
  if (lineupPosition === LineupPositions.HockeyLeftWing) return ScoreablePositions.HockeyLeftWing;

  // Basketball positions
  if (lineupPosition === LineupPositions.BasketballGuardLeft || lineupPosition === LineupPositions.BasketballGuardRight || lineupPosition === LineupPositions.BasketballFlex) return ScoreablePositions.BasketballGuard;
  if (lineupPosition === LineupPositions.BasketballForwardLeft || lineupPosition === LineupPositions.BasketballForwardRight) return ScoreablePositions.BasketballForward;
  if (lineupPosition === LineupPositions.BasketballCenter) return ScoreablePositions.BasketballCenter;

  // Cricket positions
  if (lineupPosition === LineupPositions.CricketBowlerLeft || lineupPosition === LineupPositions.CricketBowlerRight) return ScoreablePositions.CricketBowler;
  if (lineupPosition === LineupPositions.CricektBatsmenLeft || lineupPosition === LineupPositions.CricektBatsmenRight) return ScoreablePositions.CricketBatsmen;
  if (lineupPosition === LineupPositions.CricketWicketKeeperCenter) return ScoreablePositions.CricketWicketKeeper;
  if (lineupPosition === LineupPositions.CricketFlex) return ScoreablePositions.AllRounder;

  // American Football positions
  if (lineupPosition === LineupPositions.FootballQuarterBack) return ScoreablePositions.FootballQuarterBack;
  if (lineupPosition === LineupPositions.FootballWideReceiverLeft || lineupPosition === LineupPositions.FootballWideReceiverRight) return ScoreablePositions.FootballWideReceiver;
  if (lineupPosition === LineupPositions.FootballTightEnd) return ScoreablePositions.FootballTightEnd;
  if (lineupPosition === LineupPositions.FootballRunningBack || lineupPosition === LineupPositions.FootballFlex) return ScoreablePositions.FootballRunningBack;

  // Australian Football positions
  if (lineupPosition === LineupPositions.AustralianFootballRuck) return ScoreablePositions.AustralianFootballRuck;

  // Rugby positions
  if (lineupPosition === LineupPositions.RugbyFullback) return ScoreablePositions.RugbyFullback;
  if (lineupPosition === LineupPositions.RugbyHalves) return ScoreablePositions.RugbyHalves;
  if (lineupPosition === LineupPositions.RugbyHoocker) return ScoreablePositions.RugbyHoocker;
  if (lineupPosition === LineupPositions.RugbyMiddleForward) return ScoreablePositions.RugbyMiddleForward;
  if (lineupPosition === LineupPositions.RugbyEdgeForward || lineupPosition === LineupPositions.RugbyFlex) return ScoreablePositions.RugbyEdgeForward;

  // Default: return the lineup position itself
  return lineupPosition;
};

export const modifiers = [
  {
    modifier: 0,
    name: "None",
  },
  {
    modifier: 1,
    name: "Captain",
  },
  {
    modifier: 2,
    name: "GoldenBoot",
  },
];
